import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';

interface StateOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  standalone: true,
  imports: [CommonModule, SelectButtonModule, SelectModule, FormsModule]
})
export class LanguageSwitcherComponent {
  private translate = inject(TranslateService);

  selectedLocale: string | null;

  stateOptions: StateOption[] = [
    {
      label: 'DE',
      value: 'de'
    },
    {
      label: 'EN',
      value: 'en'
    }
  ];

  constructor() {
    this.selectedLocale = localStorage.getItem('language');
  }

  setLocale(locale: string): void {
    const value = locale || 'en';
    this.translate.use(value);
    localStorage.setItem('language', value);
  }
}
